﻿export const initialise = () => {
    tabIndexFix()
    navigationMenu()
    navigationBurgerMenu()
    burgerNavigation()
}

const burgerNavigation = () => {
    const burgerMenuToggles: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.header__burger-navigation-toggle')

    burgerMenuToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false')
        toggle.setAttribute('aria-controls', 'burger-navigation')
        
        toggle.addEventListener('click', () => {
            const dialog: HTMLDialogElement | null = document.querySelector('.header__container-burger-navigation')
            if (!dialog) return

            if (dialog.open) {
                dialog.close()
                burgerMenuToggles.forEach((toggle) => {
                    toggle.setAttribute('aria-expanded', 'false')
                })
                return
            }

            dialog.showModal()
            // make all toggles aria-expanded true
            burgerMenuToggles.forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'true')
            })

            const firstLink: HTMLAnchorElement | null = dialog.querySelector('a')
            if (firstLink) {
                setTimeout(() => {
                    firstLink.focus()
                }
                , 100)
            }

            dialog.addEventListener('close', function closeDialog() {
                dialog.close()
                burgerMenuToggles.forEach((toggle) => {
                    toggle.setAttribute('aria-expanded', 'false')
                })
                dialog.removeEventListener('close', closeDialog)
            })
        })
    })
}

const tabIndexFix = () => {
    const navigations = document.querySelectorAll<HTMLElement>('.mainNav-widget')
    navigations.forEach((navigation) => {
        const items = navigation.querySelectorAll<HTMLElement>('[tabindex]')
        items.forEach((item => item.setAttribute('tabindex', '0')))
    })
}

const navigationMenu = () => {    
    const header = document.querySelector<HTMLElement>('header.header')
    if (!header) return
    const menus = header.querySelectorAll<HTMLElement>('.navRoot .hasChildren')
    menus.forEach((menu) => {
        const menuItem = menu.querySelector<HTMLElement>('.text-node a')
        if (!menuItem) return

        const childMenu = menu.querySelector<HTMLElement>('.navList')
        if (!childMenu) return

        menu.addEventListener('mouseenter', (event) => {
            const target = event.target as HTMLElement
            if (!target) return
            openMenu(target, childMenu)
        })

        menu.addEventListener('mouseleave', (event) => {
            const target = event.target as HTMLElement
            if (!target) return
            closeMenu(target, childMenu)
        })

        menuItem.addEventListener('keyup', (event) => {
            const target = event.target as HTMLElement
            const parent = target.parentElement?.parentElement
            if (!parent) return
            openMenu(parent, childMenu)
        })
    })
}

const navigationBurgerMenu = () => {    
    const header = document.querySelector<HTMLElement>('dialog.header__container-burger-navigation')
    if (!header) return
    const menus = header.querySelectorAll<HTMLElement>('.navRoot .hasChildren')
    menus.forEach((menu) => {
        const childMenu = menu.querySelector<HTMLElement>('.navList')
        if (!childMenu) return

        const toggle = menu.querySelector<HTMLElement>('.attrax-child-nav-trigger')
        if (!toggle) return

        toggle.addEventListener('click', () => {
            toggleMenu(menu, childMenu)
        })

        toggle.addEventListener('keyup', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                toggleMenu(menu, childMenu)
            }
        })
    })
}

const openMenu = (parent: HTMLElement, menu: HTMLElement) => {
    parent.setAttribute('aria-expanded', 'true')
    menu.setAttribute('aria-hidden', 'false')

    document.addEventListener('keyup', function tabAway(event) {
        const target = event.target as HTMLElement
        if (event.key !== 'Tab') return
        if (!parent.contains(target)) {
            closeMenu(parent, menu)
            document.removeEventListener('keyup', tabAway)
        }
    })

    document.addEventListener('click', function clickAway(event) {
        const target = event.target as HTMLElement
        if (!parent.contains(target)) {
            closeMenu(parent, menu)
            document.removeEventListener('click', clickAway)
        }
    })
}

const closeMenu = (parent: HTMLElement, menu: HTMLElement) => {
    parent.setAttribute('aria-expanded', 'false')
    menu.setAttribute('aria-hidden', 'true')
}

const toggleMenu = (parent: HTMLElement, menu: HTMLElement) => {
    const isExpanded = parent.getAttribute('aria-expanded') === 'true'
    parent.setAttribute('aria-expanded', (!isExpanded).toString())
    menu.setAttribute('aria-hidden', isExpanded.toString())
}